import ProjectItem from './project-item';

export default ProjectItem;
